/**
 * Image download protection — smarter logic
 * - Block save/drag/long-press on content images
 * - Ignore nav/footer icons & tiny UI images
 * - Share sheet uses FULL article URL when target is inside a blog card link
 */
(function () {
  'use strict';
  if (window.__LT_NO_IMG_DL__) return;
  window.__LT_NO_IMG_DL__ = true;

  var SHARE_COOLDOWN_MS = 1200;
  var lastShareAt = 0;
  var ICON_MAX = 48;
  var pendingShareUrl = null;

  function pageUrl() {
    return location.href.split('#')[0].split('?')[0] + (location.search || '');
  }
  function pageTitle() {
    return document.title || location.hostname;
  }

  /** Prefer full article URL from nearest blog/article card link */
  function resolveShareUrl(t) {
    try {
      var el = t && t.nodeType === 1 ? t : (t && t.parentElement);
      if (el && el.closest) {
        var a = el.closest('a.sdn-blog-item, a.sdn-card, a[href*="/blogs/"]');
        if (a && a.href) {
          var href = a.href;
          // must be same-site article path, not just /blogs/handle alone without article
          if (/\/blogs\/[^\/]+\/[^\/?#]+/.test(href)) {
            return href.split('#')[0];
          }
          if (href.indexOf('/blogs/') !== -1 && href.replace(/\/$/, '') !== location.href.replace(/\/$/, '')) {
            return href.split('#')[0];
          }
        }
        // featured / home cards
        var feat = el.closest('a[href*="/blogs/"]');
        if (feat && feat.href && /\/blogs\/[^\/]+\/[^\/?#]+/.test(feat.href)) {
          return feat.href.split('#')[0];
        }
      }
    } catch (e) {}
    return pageUrl();
  }

  function ensureSheet() {
    var el = document.getElementById('lt-share-sheet');
    if (el) return el;
    el = document.createElement('div');
    el.id = 'lt-share-sheet';
    el.className = 'lt-share-sheet';
    el.hidden = true;
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
    el.setAttribute('aria-label', 'Share');
    el.innerHTML =
      '<div class="lt-share-panel">' +
      '<h3>Share this page</h3>' +
      '<p class="lt-share-hint">Image download is disabled. Share the page instead.</p>' +
      '<p class="lt-share-url" id="lt-share-url-preview" style="font-size:11px;color:#6b6570;word-break:break-all;margin:0 0 12px;"></p>' +
      '<div class="lt-share-grid">' +
      '<button type="button" data-lt-share="native">System share</button>' +
      '<button type="button" data-lt-share="copy">Copy link</button>' +
      '<a data-lt-share="whatsapp" target="_blank" rel="noopener">WhatsApp</a>' +
      '<a data-lt-share="twitter" target="_blank" rel="noopener">X / Twitter</a>' +
      '<a data-lt-share="facebook" target="_blank" rel="noopener">Facebook</a>' +
      '<a data-lt-share="telegram" target="_blank" rel="noopener">Telegram</a>' +
      '</div>' +
      '<button type="button" class="lt-share-close" data-lt-share="close">Close</button>' +
      '</div>';
    document.body.appendChild(el);

    el.addEventListener('click', function (e) {
      if (e.target === el) closeSheet();
    });
    el.addEventListener('click', function (e) {
      var t = e.target.closest('[data-lt-share]');
      if (!t) return;
      var act = t.getAttribute('data-lt-share');
      var url = pendingShareUrl || pageUrl();
      if (act === 'close') {
        closeSheet();
        return;
      }
      if (act === 'copy') {
        e.preventDefault();
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(function () {
            t.textContent = 'Copied!';
            setTimeout(function () { t.textContent = 'Copy link'; }, 1500);
          }).catch(function () {
            window.prompt('Copy link:', url);
          });
        } else {
          window.prompt('Copy link:', url);
        }
        return;
      }
      if (act === 'native') {
        e.preventDefault();
        if (navigator.share) {
          navigator.share({ title: pageTitle(), url: url }).catch(function () {});
        }
        return;
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeSheet();
    });
    return el;
  }

  function openSheet(fromTarget) {
    var now = Date.now();
    if (now - lastShareAt < SHARE_COOLDOWN_MS) return;
    lastShareAt = now;
    var shareUrl = fromTarget ? resolveShareUrl(fromTarget) : pageUrl();
    pendingShareUrl = shareUrl;
    var el = ensureSheet();
    var prev = el.querySelector('#lt-share-url-preview');
    if (prev) prev.textContent = shareUrl;
    var urlEnc = encodeURIComponent(shareUrl);
    var textEnc = encodeURIComponent(pageTitle() + ' ' + shareUrl);
    var map = {
      whatsapp: 'https://wa.me/?text=' + textEnc,
      twitter: 'https://twitter.com/intent/tweet?url=' + urlEnc + '&text=' + encodeURIComponent(pageTitle()),
      facebook: 'https://www.facebook.com/sharer/sharer.php?u=' + urlEnc,
      telegram: 'https://t.me/share/url?url=' + urlEnc + '&text=' + encodeURIComponent(pageTitle())
    };
    Object.keys(map).forEach(function (k) {
      var a = el.querySelector('[data-lt-share="' + k + '"]');
      if (a) a.setAttribute('href', map[k]);
    });
    el.hidden = false;
    document.body.classList.add('lt-share-open');
  }

  function closeSheet() {
    var el = document.getElementById('lt-share-sheet');
    if (el) el.hidden = true;
    document.body.classList.remove('lt-share-open');
  }

  function isChromeZone(el) {
    if (!el || !el.closest) return false;
    return !!el.closest(
      'header, footer, nav, [role="navigation"], .header, .footer, .menu, .navbar, ' +
      'button, [role="button"], .icon, .icons, .social-icons, .share-buttons, ' +
      '.sdn-share, .v-adl, .v-adl-sticky'
    );
  }

  function isTiny(el) {
    try {
      var r = el.getBoundingClientRect ? el.getBoundingClientRect() : null;
      if (r && r.width > 0 && r.height > 0) {
        return r.width <= ICON_MAX && r.height <= ICON_MAX;
      }
      var w = parseInt(el.getAttribute('width'), 10) || el.naturalWidth || 0;
      var h = parseInt(el.getAttribute('height'), 10) || el.naturalHeight || 0;
      if (w && h) return w <= ICON_MAX && h <= ICON_MAX;
    } catch (e) {}
    return false;
  }

  function resolveMediaNode(t) {
    if (!t || !t.tagName) return null;
    var tag = t.tagName.toLowerCase();
    if (tag === 'img' || tag === 'picture' || tag === 'svg' || tag === 'canvas') return t;
    if (tag === 'source' && t.parentElement) return t.parentElement;
    if (t.closest) {
      var m = t.closest('img, picture, svg, canvas, [data-no-download]');
      if (m) return m;
      var box = t.closest(
        'figure, .media, .product-media, .article-featured-image, .sdn-article-hero, .thumb, .sdn-blog-item'
      );
      if (box && box.querySelector) {
        return box.querySelector('img, svg, canvas') || box;
      }
    }
    return null;
  }

  function shouldBlock(t) {
    var node = resolveMediaNode(t);
    if (!node) return false;
    if (isChromeZone(node) && isTiny(node)) return false;
    if (node.getAttribute && node.getAttribute('data-allow-download') === '1') return false;
    return true;
  }

  function shouldShare(t) {
    var node = resolveMediaNode(t);
    if (!node) return false;
    if (isChromeZone(node) && isTiny(node)) return false;
    if (isTiny(node)) return false;
    if (node.closest) {
      var inContent = node.closest(
        'article, main, .sdn-article, .sdn-article-body, .sdn-article-hero, ' +
        '.sdn-blog-item, .product, .product-media, .rte, figure, [role="main"]'
      );
      if (inContent) return true;
    }
    return !isTiny(node);
  }

  // LEFT CLICK on blog cards must always navigate — never open share sheet
  document.addEventListener(
    'click',
    function (e) {
      if (e.button !== 0) return;
      var a = e.target && e.target.closest && e.target.closest('a.sdn-blog-item, a.sdn-card');
      if (!a || !a.href) return;
      // ensure navigation to full absolute URL
      if (a.href.indexOf('http') === 0) {
        // allow default navigation; do not preventDefault
        return;
      }
    },
    true
  );

  document.addEventListener(
    'contextmenu',
    function (e) {
      if (!shouldBlock(e.target)) return;
      e.preventDefault();
      e.stopPropagation();
      if (shouldShare(e.target)) openSheet(e.target);
    },
    true
  );

  document.addEventListener(
    'dragstart',
    function (e) {
      if (!shouldBlock(e.target)) return;
      e.preventDefault();
      e.stopPropagation();
    },
    true
  );

  document.addEventListener(
    'selectstart',
    function (e) {
      if (shouldBlock(e.target)) e.preventDefault();
    },
    true
  );

  var pressTimer = null;
  var startX = 0;
  var startY = 0;
  var pressTarget = null;

  document.addEventListener(
    'touchstart',
    function (e) {
      if (!e.touches || !e.touches[0]) return;
      if (!shouldBlock(e.target) || !shouldShare(e.target)) return;
      pressTarget = e.target;
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      clearPress();
      pressTimer = setTimeout(function () {
        pressTimer = null;
        if (pressTarget) openSheet(pressTarget);
      }, 480);
    },
    { passive: true, capture: true }
  );

  function clearPress() {
    if (pressTimer) {
      clearTimeout(pressTimer);
      pressTimer = null;
    }
  }

  document.addEventListener(
    'touchmove',
    function (e) {
      if (!pressTimer || !e.touches || !e.touches[0]) return;
      var dx = Math.abs(e.touches[0].clientX - startX);
      var dy = Math.abs(e.touches[0].clientY - startY);
      if (dx > 12 || dy > 12) clearPress();
    },
    { passive: true, capture: true }
  );
  document.addEventListener('touchend', clearPress, true);
  document.addEventListener('touchcancel', clearPress, true);

  function harden(el) {
    if (!el || el.nodeType !== 1) return;
    if (el.getAttribute('data-allow-download') === '1') return;
    el.setAttribute('draggable', 'false');
    el.setAttribute('data-no-download', '1');
    try {
      el.style.webkitUserDrag = 'none';
      el.style.userSelect = 'none';
      el.style.webkitTouchCallout = 'none';
    } catch (e) {}
  }

  function markImages(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var imgs = scope.querySelectorAll('img, picture, svg, canvas');
    for (var i = 0; i < imgs.length; i++) {
      harden(imgs[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { markImages(document); });
  } else {
    markImages(document);
  }

  try {
    var mo = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var nodes = muts[i].addedNodes;
        if (!nodes) continue;
        for (var j = 0; j < nodes.length; j++) {
          var n = nodes[j];
          if (!n || n.nodeType !== 1) continue;
          if (n.matches && n.matches('img, picture, svg, canvas')) harden(n);
          else if (n.querySelectorAll) markImages(n);
        }
      }
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  } catch (e) {}

  window.LiveTrafficShareSheet = { open: openSheet, close: closeSheet };
})();
